import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-menu-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent {

  @Input() text: string;
  @Input() reverse: boolean;
  @Input() icon: string;
  @Input() fontWeight: 'normal' | 'bold' | undefined;
  @Output() clicked = new EventEmitter<any>();

  constructor() {
    if (!this.icon) {
      this.icon = 'add';
    }
  }

  onClick(): void {
    this.clicked.emit();
  }

}
